import { render, staticRenderFns } from "./RecordDetails.vue?vue&type=template&id=6741d6bd&lang=html"
import script from "./RecordDetails.vue?vue&type=script&lang=js"
export * from "./RecordDetails.vue?vue&type=script&lang=js"
import style0 from "./RecordDetails.vue?vue&type=style&index=0&id=6741d6bd&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports